
(function ($) {
  const $fb = $('.social-fb');
  const $insta = $('.social-insta');

  if ($fb) {
    $fb.html("<img src='/themes/custom/perspectief/assets/dist/images/icons/facebook.svg'/>" );
  }

  if ($insta) {
    $insta.html("<img src='/themes/custom/perspectief/assets/dist/images/icons/instagram.svg'/>" );
  }
})(jQuery);
